import { SealCheck } from "@phosphor-icons/react";
import type { ReactNode } from "react";

interface ModelBillingOverviewProps {
  modelName: string;
  description: string | null;
  children?: ReactNode;
}

export function ModelBillingOverview({
  modelName,
  description,
  children,
}: ModelBillingOverviewProps) {
  return (
    <div className="xl:sticky xl:top-[calc(var(--header-height)+1rem)] space-y-4">
      {children}

      {description ? (
        <>
          <div
            className="prose dark:prose-invert"
            // biome-ignore lint/security/noDangerouslySetInnerHtml: this is managed by us
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <hr />
        </>
      ) : null}

      <p>
        <a href="https://replicate.com/docs/billing">Check out our docs</a> for
        more information about how pricing works on Replicate. Looking for
        volume pricing? <a href="mailto:sales@replicate.com">Get in touch</a>.
      </p>
    </div>
  );
}
